import React from 'react';
import { Card, CardHeader, CardBody, CardFooter } from 'reactstrap';
import Skeleton from 'react-loading-skeleton';
import AddButton from 'components/buttons/AddButton';
import { faPlay, faSync } from '@fortawesome/free-solid-svg-icons';
import IconButtonWithTooltip from 'components/buttons/IconButtonWithTooltip';

function CardWithLoader({ title, isLoading, children, footerButtonClick=null, footerButtonText=null, playButtonClick=null, playButtonText=null, lines=3, height=80, footerButton }) {
    return (
        <Card>
            {title &&
                <CardHeader className="d-flex align-items-center justify-content-between">
                    <h5 className="title">{title}</h5>
                    {!footerButtonClick && playButtonClick && <IconButtonWithTooltip translationId={playButtonText} icon={faSync} onClick={playButtonClick} type="Button" />}
                </CardHeader>
            }
            <CardBody style={{minHeight: "0px"}}>
                {isLoading ? 
                    <Skeleton height={height} count={lines} />
                :
                    children
                }
            </CardBody>
            {footerButtonClick ?
                <CardFooter>
                    <AddButton onClick={footerButtonClick} text={footerButtonText}/>
                    {playButtonClick && <IconButtonWithTooltip translationId={playButtonText} icon={faPlay} onClick={playButtonClick} type="Button" />}
                    {footerButton}
                </CardFooter>
            : footerButton &&
                <CardFooter>
                    {footerButton}
                </CardFooter>
            }
        </Card>
  );
}

export default CardWithLoader;
